import gql from 'graphql-tag';

export default gql`
  fragment assetFields on Asset {
    assetId
    organisationId
    filename
    title
    description
    tags
    altText
    metaData
    createdAt
    product
    createdByUser {
      firstName
      lastName
      userId
    }
    updatedAt
    updatedByUser {
      firstName
      lastName
    }
    assetFiles {
      THUMBNAIL {
        assetFileId
        type
        status
        sourceUrl
        metaData
      }
      ORIGINAL {
        assetFileId
        type
        status
        sourceUrl
        metaData
      }
      HD {
        assetFileId
        type
        status
        sourceUrl
        metaData
      }
      SD {
        assetFileId
        type
        status
        sourceUrl
        metaData
      }
      CAPTION {
        assetFileId
        type
        status
        sourceUrl
        metaData
      },
      VTT_CAPTION {
        assetFileId
        type
        status
        sourceUrl
        metaData
      }
    }
  }
`;